module.exports = __webpack_public_path__ + "67395c0a8f5e3093bc6ee1dccfd02d02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jcb.png
// module id = 519
// module chunks = 0